import { useState } from 'react';
import Filter from '../../components/Filter/Filter';
import DataMap from '../../components/DataMap/DataMap';
import { Icon } from 'leaflet';
import ActionGrid from '../../components/ActionGrid/ActionGrid';
import dayjs from 'dayjs';
import {useDeviceFilter} from '../../hooks/useFilter';
import { GetParkingDevices, getModalData } from '../../Helpers/fetchDevices';
import LCLineChart from '../../components/Charts/LCLineChart/LCLineChart';
import Typography from '@mui/material/Typography';
import TextField from '@mui/material/TextField';
import Card from '@mui/material/Card';
import CardHeader from '@mui/material/CardHeader';
import CardContent from '@mui/material/CardContent';
import DataTable from '../../components/DataTable/DataTable';
import { useParkingDeviceStatuses } from '../../hooks/useParkingDeviceStatuses';

const customIcon = new Icon({
    iconUrl : require('../../components/DataMap/assets/marker.png'),
    iconSize: [38,38]
})

const actions = [
    'open',
    'error',
    'close',
    'join',
];

const parkingStatusColumns = [
  { label: 'UUID', key: 'deviceUid' },
  { label: 'Είδος Θέσης', key: 'parkingSpotType' },
  { label: 'Τελευταίο Μήνυμα', key: 'lastMessageAt' },
  { label: 'Κατάσταση', key: 'status' },
];

const ParkingSensors = () => {
    const [selectedDevices, setSelectedDevices] = useState([]);
    const [filters, setFilters] = useState({
      search: "",
      deviceStates: {
        open: true,
        error: true,
        close: true,
        join: true,
      },
    });

    const { devices, statsForGraph, statusCounts, handleSearchClick} = useDeviceFilter(filters, GetParkingDevices, "parking");
    const { deviceStatuses } = useParkingDeviceStatuses();

    const parkingStatusRows = deviceStatuses.map((device) => ({
      ...device,
      parkingSpotType: device.parkingSpotType || '—',
      lastMessageAt: device.lastMessageAt
        ? dayjs(device.lastMessageAt).format('DD/MM/YYYY HH:mm')
        : '—',
    }));
    
    const handleMarkersSelected = (results) => {
      if (results) {
        setSelectedDevices(results);
      }
    };

    return (
        <>  
            <div className="mb-4">
                <ActionGrid actions = {actions} statusCounts = {statusCounts}/>
            </div>

            <div className="mb-4">
              <Card>
                <CardHeader title={"Φίλτρα Αναζήτησης"}/>
                <CardContent>
                  <Typography>Αναζήτηση βάσει λέξεων κλειδιών (όνομα, οδός κλπ)</Typography>
                  <TextField
                    value={filters.search}
                    onChange={(e) => setFilters((prev) => ({ ...prev, search: e.target.value }))}
                    fullWidth
                  />
                  <Filter filters={filters} setFilters={setFilters} dateRanges={false} onSearch={handleSearchClick} />
                </CardContent>
              </Card>
            </div>
            
            <div className="mb-4">
                <DataMap markers ={devices} customIcon = {customIcon} deviceType ={"parking"} onMarkersSelected={handleMarkersSelected} modalFetcher={getModalData}/>
            </div>

            <div className="mb-4">
              <Card>
                <CardHeader title="Κατάσταση συσκευών" />
                <CardContent>
                  <DataTable columns={parkingStatusColumns} data={parkingStatusRows} />
                </CardContent>
              </Card>
            </div>

            
        </>
    );
};

export default ParkingSensors;
